import IconFileCode from "components/icons/icn-file-code.icon";
import { UploadDynamicInventoryPolicy } from "components/import-export-json/dynamic-inventory-policy.types";
import { validateDynamicInventoryPolicyDelimiter } from "components/import-export-json/dynamic-inventory-policy.utils";
import { forwardRef } from "react";
import intl from "react-intl-universal";
import { useCSVReader } from "react-papaparse";
import StyledCSVReader from "./styled";

interface FileUploadDynamicInventoryPolicyProps {
  handleReadFile: (data: IReadFileDynamicInventoryPolicy) => void;
  setCsv: (xls: UploadDynamicInventoryPolicy[]) => void;
  setErrors: (error: string[]) => void;
  setFileName: (fileName: string) => void;
}

type IAcceptedFile = {
  acceptedFile: File | null;
  getRootProps: () => React.HTMLProps<HTMLDivElement>;
};

type IReadFileDynamicInventoryPolicy = {
  data: UploadDynamicInventoryPolicy[];
  errors: [];
  meta: [];
};

const StyledCSVReaderWithRef = forwardRef<HTMLDivElement>((props) => (
  <StyledCSVReader {...props} />
));

const FileUploadDynamicInventoryPolicy = ({
  handleReadFile,
  setCsv,
  setErrors,
  setFileName,
}: FileUploadDynamicInventoryPolicyProps) => {
  const { CSVReader } = useCSVReader();

  const handleUploadFile = (fileData: IReadFileDynamicInventoryPolicy) => {
    if (fileData.data.length > 4001) {
      setErrors([intl.get("master-data.general-configuration.maxLineError")]);
    } else {
      const _fileData = fileData.data.filter((item) =>
        Object.values(item).some((value) => value && value.toString().trim() !== "")
      ) as unknown as UploadDynamicInventoryPolicy;

      setCsv([_fileData]);
      handleReadFile({ data: [_fileData], errors: [], meta: [] });
    }
  };

  return (
    <CSVReader
      onUploadAccepted={handleUploadFile}
      config={{
        encoding: "iso-8859-1",
        header: true,
        delimiter: validateDynamicInventoryPolicyDelimiter(),
      }}
    >
      {({ acceptedFile, getRootProps }: IAcceptedFile) => {
        if (acceptedFile?.name) {
          setFileName(acceptedFile.name);
        }
        return (
          <StyledCSVReaderWithRef {...getRootProps()}>
            <label>{intl.get("master-data.general.stockPolicyModal.archive")}</label>
            <div className="input-container">
              {!acceptedFile && (
                <span>{intl.get("master-data.general.stockPolicyModal.searchArchive")}</span>
              )}
              {acceptedFile && <span>{acceptedFile.name}</span>}
              <div className="button-upload">
                <IconFileCode />
                <span>{intl.get("master-data.general.stockPolicyModal.select")}</span>
              </div>
            </div>
            <p>{intl.get("master-data.general.dynamicInventoryPolicyModal.maxLines")}</p>
          </StyledCSVReaderWithRef>
        );
      }}
    </CSVReader>
  );
};

export { FileUploadDynamicInventoryPolicy };
